var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoInformacao01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1556",
    d: "M25.3,31.7l-0.5,2c-1.5,0.6-2.6,1-3.5,1.3c-1,0.3-2,0.5-3.1,0.5c-1.5,0.1-3-0.4-4.1-1.3 c-1-0.8-1.5-2-1.5-3.3c0-0.5,0-1.1,0.1-1.6c0.1-0.5,0.2-1.2,0.4-1.8l1.8-6.5c0.2-0.6,0.3-1.2,0.4-1.8c0.1-0.5,0.2-1,0.2-1.5 c0.1-0.6-0.1-1.2-0.5-1.7c-0.6-0.4-1.3-0.6-2-0.5c-0.5,0-1,0.1-1.5,0.2c-0.5,0.1-0.9,0.3-1.3,0.4l0.5-2c1.2-0.5,2.4-0.9,3.5-1.3 c1-0.3,2.1-0.5,3.1-0.5c1.5-0.1,2.9,0.4,4.1,1.3c1,0.8,1.5,2.1,1.4,3.3c0,0.3,0,0.8-0.1,1.5c-0.1,0.7-0.2,1.3-0.4,2l-1.8,6.5 c-0.2,0.6-0.3,1.2-0.4,1.8c-0.1,0.5-0.2,1-0.2,1.5c-0.1,0.6,0.1,1.3,0.6,1.8c0.6,0.4,1.3,0.5,2,0.5c0.5,0,1-0.1,1.5-0.2 C24.5,32,24.9,31.9,25.3,31.7z M25.7,4.6c0,1.1-0.5,2.2-1.3,2.9c-0.8,0.8-1.9,1.2-3.1,1.2c-1.1,0-2.3-0.4-3.1-1.2 C16.7,6,16.6,3.6,18,2c0.1-0.1,0.2-0.2,0.3-0.3c1.7-1.6,4.4-1.6,6.2,0C25.3,2.4,25.8,3.5,25.7,4.6L25.7,4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInformacao01);
export default __webpack_public_path__ + "static/media/ico-informacao-01.ab755ba6f731b7dbac16b4a21c9f61f0.svg";
export { ForwardRef as ReactComponent };